import { render, staticRenderFns } from "./WorkOSRedirect.vue?vue&type=template&id=eef2075e&scoped=true"
import script from "./WorkOSRedirect.vue?vue&type=script&lang=js"
export * from "./WorkOSRedirect.vue?vue&type=script&lang=js"
import style0 from "./WorkOSRedirect.vue?vue&type=style&index=0&id=eef2075e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef2075e",
  null
  
)

export default component.exports